import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`@import url("https://fonts.googleapis.com/css?family=Ubuntu+Condensed&display=swap")`;
